'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "selectedColorSet", "selected", "children", "color", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { deprecatedPropWarning } from "../../logging.mjs";
import { addColorSet, defaultColorSetName, defaultTheme, textClass } from "../../styles/index.mjs";
import { TagElement } from "./Tag.mjs";
import { TagFocus } from "./TagFocus.mjs";
import { TagInner } from "./TagInner.mjs";
import { TagInnerSelected } from "./TagInnerSelected.mjs";
/**
 * Use Tags to present a collection of attributes to describe a piece of content.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-tag--docs) |
 * [Encore site](https://encore.spotify.net/web/components/tags) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Tag) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-9101&t=e8dHQIUZZe5vvdNY-1)
 */
export var Tag = function Tag(_ref) {
  var colorSet = _ref.colorSet,
    selectedColorSet = _ref.selectedColorSet,
    selected = _ref.selected,
    children = _ref.children,
    color = _ref.color,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  if (selected) {
    deprecatedPropWarning('selected', 'Tag', 'Please use the Chip component with a selected prop instead.');
  }
  if (selectedColorSet) {
    deprecatedPropWarning('selectedColorSet', 'Tag', 'Please use the Chip component with a selectedColorSet prop instead.');
  }
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var TagInnerComponent = selected ? TagInnerSelected : TagInner;
  var currentColorSet = selected ? selectedColorSet || 'invertedDark' : colorSet;
  var fallbackSet = defaultTheme[currentColorSet || defaultColorSetName];
  return /*#__PURE__*/React.createElement(TagElement, Object.assign({}, props, {
    colorSet: currentColorSet,
    fallbackSet: fallbackSet,
    isUsingKeyboard: isUsingKeyboard,
    "data-encore-id": ENCORE_DATA_IDS.Tag
  }), /*#__PURE__*/React.createElement(TagInnerComponent, {
    className: cx(textClass('marginalBold'), addColorSet(currentColorSet, className)),
    $colorSet: currentColorSet,
    $fallbackSet: fallbackSet
  }, children), /*#__PURE__*/React.createElement(TagFocus, null));
};